/** @module csi/datasheet/CanvasToolbar */
define([
	"dojo/_base/declare",
	"csi/dojoExtensions",
	"csi/view/Toolbar"
], function(declare,dojoExtensions,Toolbar) {

	return declare(Toolbar, {
		postCreate: function() {
			dojoExtensions.disableToolbarFocus(this);
			this.inherited(arguments);
		},

		/**
		 * Handle visibility of separators
		 */
		enablePlugins: function() {
			this.cleanupToolbarChildren(this.dijitToolbarNode.getChildren());
		},

		/**
		 * Do not disable plugins while executing actions
		 */
		disablePlugins: function() { }
	});
});